import React from 'react';
import { connect, useSelector } from 'react-redux';
import { randomUuid } from '../../../classes/lib-common';

import ComponentpediaLink, {ComponentpediaLinkTypes} from '../componentpedia';

import { collapseSections } from '../../../state/actions/app'
import { setElementToExclude, setExclusionToRemove } from '../../../state/actions/exclusions'
import RegistryUrl from '../registry.url';
import DownloadStabilityCSV from './DownloadStabilityCSV';


const mapStateAsProps = state => ({
	readonly: state.projectInfo.projectInfo.readonly,
	privateMode: state.projectInfo.urlParams.mode,
	summary: state.projectInfo.stability.stability,
	exclusions: state.projectInfo.exclusions,
	isLatest: state.projectInfo.isLatestReport,
	// toggledLanguages: state.languagesFilter.toggledLanguages,
	collapsed: state.summariesState.stability,
	info: state.projectInfo
})

const mapDispatchAsProps = dispatch => ({
	newMitigations: (reason, newMitigation, isGlobalExclusionAvailable) => dispatch(setElementToExclude(reason, newMitigation, isGlobalExclusionAvailable)),
	removeMitigation: (advice, isGlobalExclusionAvailable) => dispatch(setExclusionToRemove(advice, isGlobalExclusionAvailable)),
	collapse: (current) => dispatch(collapseSections("stability", current))
})

const Component = ({ hasExclusions, collapseState, indexes, shouldShowActions, language, version, exclusions, ignoreAvailable, restoreAvailable, newMitigations, removeMitigation, summary, updateSummary, findDependencyInTree, isLatest, scope }) => {
	const collapseComponentView = (report, version) => {
		const isCollapsed = !summary.reports[report].versions[version].expanded;
		summary.reports[report].versions[version].expanded = isCollapsed;
		updateSummary(summary)
	}


	const PatchIn = () => {
		return (
			version.newPatchVersionAvailable ?
				<div className="version-new-release">
					<span className="version-release-title">new patch release:</span> <strong>{version.latestPatch}</strong>
				</div> :
				<div className="version-new-release version-release-empty">-</div>
		)
	}
	const MinorIn = () => {
		return (
			version.newMinorVersionAvailable ?
				<div className="version-new-release">
					<span className="version-release-title">new minor release:</span> <strong>{version.latestMinor}</strong>
				</div> :
				<div className="version-new-release version-release-empty">-</div>
		)
	}
	const MajorIn = () => {
		return (
			version.newMajorVersionAvailable ?
				<div className="version-new-release">
					<span className="version-release-title">new major release:</span> <strong>{version.latestMajor}</strong>
				</div> :
				<div className="version-new-release version-release-empty">-</div>
		)
	}

	const Actions = () => {
		const showCorrectActionButton = (id, version, language) => {
			if (version.exclusions.length) {
				restoreAvailable[version.exclusions[0].id] = {
					uuid: version.exclusions[0].id,
					library: version.name + ":" + version.version
				}
			}
			else {

				version.collapse = false;
				ignoreAvailable[id] = {
					title: "Ignore dependency: ",
					domain: "stability",
					kind: "library",
					content: {
						library: {
							name: version.name,
							language: language,
						},
						version: version.version,
					}
				}
			}
		}
		const id = randomUuid();
		showCorrectActionButton(id, version, language);

		return (
			shouldShowActions ?
				<div className="version-new-release">
					{ignoreAvailable[id] ?
						<button className="btn btn-secondary btn-action gray"
							onClick={() => newMitigations("ignored", ignoreAvailable[id])}>
							Ignore
						</button> :
						<button className="btn btn-primary btn-action"
							title={
								version.exclusions[0].readonly ?
									"This exclusion is embedded in the codebase on the '.meterian' file, and therefore it cannot be removed from this UI."
									: "Remove this exclusion"
							}
							disabled={version.exclusions[0].readonly}
							onClick={() => removeMitigation(restoreAvailable[version.exclusions[0].id])}>
							Restore
						</button>
					}
				</div> : ""
		)
	}

	const Description = () => {
		return (
			<div className="w-100">
				{
					version.exclusions.length ? <p className="ml-3">{version.exclusions[0].description}</p> : null
				}
			</div>
		)
	}

	const Version = () => {
		return (
			<React.Fragment>
				<PatchIn />
				<MinorIn />
				<MajorIn />
				<Actions />
				<Description />
			</React.Fragment>
		)
	}

	const versionWrapperStyle = `${collapseState ? "p-0 " : ""}version-wrapper ${hasExclusions ? "stability-exclusion" : ""}`;
	const collapsedActionsStyle = "version-library d-inline-flex text-truncate" + version.collapse && collapseState ? "version-collapsed" : "";
	const libraryName = version.version !== "--" ? version.name + ":" + version.version : version.name;
	return (
		<div className={versionWrapperStyle} key={version.name} id={"stability-" + version.name + version.version}>
			{
				!hasExclusions ?
					<React.Fragment>

						<div className="version-library text-truncate" title={libraryName + (version.scope ? " (" + version.scope + ")" : "")}>
							<div className={(isLatest ? "text-link " : "") + "pr-0 mr-1"} style={{ whiteSpace: "pre-wrap" }}
								title={`${libraryName} ${isLatest ? "See in dependency tree" : ""}`} 
								tabIndex={1}
								onClick={()=>findDependencyInTree(language, version.name + " " + version.version, {latest: isLatest}) }
								onKeyDown={(e)=>findDependencyInTree(language, version.name + " " + version.version, {key: e.key, notLatest: !isLatest}) } >
								{libraryName}
							</div>
							<ComponentpediaLink language={language} name={version.name} version={version.version} type={ComponentpediaLinkTypes.SM} />
							<RegistryUrl language={language} name={version.name} version={version.version} />
						</div>

						<div className="version-scope">
							{version.scope ? <small className="badge badge-inverted-primary">{version.scope}</small> : ""}
						</div>
					</React.Fragment>
					:
					<React.Fragment>
						<div className={collapsedActionsStyle} title={libraryName + (version.scope ? " (" + version.scope + ")" : "")}>
							{isLatest ?
								<span className="text-link" value="" title="See in dependency tree" 
									tabIndex={0}
									onClick={() => { findDependencyInTree(language, version.name +  " " + version.version) }} 
									onKeyUp={(e) => { findDependencyInTree(language, version.name +  " " + version.version, {key: e.key}) }}>
									{libraryName} {version.scope ? <small className="opaque"><i>({version.scope})</i></small> : ""}
								</span> :
								<span value="" >
									{libraryName} {version.scope ? <small className="opaque"><i>({version.scope})</i></small> : ""}
								</span>
							}
							<div className="version-expand pointer rounded-circle ml-2 d-inline-block" onClick={() => collapseComponentView(indexes.report, indexes.version)}>
								{collapseState ? <i className="fas fa-plus"></i> : <i className="fas fa-minus"></i>}
							</div>
						</div>
						<div className="version-scope" />
					</React.Fragment>
			}
			{
				!hasExclusions || (hasExclusions && !collapseState) ? <Version /> : ""
			}
		</div>
	)

}



class Stability extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			error: false,
			summary: this.props.summary,
			collapsed: false
		}
		this.ignoreAvailable = {};
		this.restoreAvailable = {};
		this.summary = {};
	}


	updateSummary = (summary) => {
		this.setState({ summary })
	}

	Versions(versions, language, repIndex) {

		const { exclusions } = this.props;

		versions.sort((a, b) => a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1)

		return versions.map((version, verIndex) => {

			const indexes = { report: repIndex, version: verIndex }
			return (
				<Component key={"component" + repIndex + verIndex}
					hasExclusions={version.exclusions && version.exclusions.length}
					collapseState={!this.summary.reports[repIndex].versions[verIndex].expanded}
					indexes={indexes}
					shouldShowActions={this.props.privateMode && !this.props.readonly && this.props.isLatest}
					language={language}
					version={version}
					exclusions={exclusions}
					ignoreAvailable={this.ignoreAvailable}
					restoreAvailable={this.restoreAvailable}
					newMitigations={this.props.newMitigations}
					removeMitigation={this.props.removeMitigation}
					summary={this.summary}
					updateSummary={this.updateSummary}
					findDependencyInTree={this.props.findDependencyInTree}
					isLatest={this.props.isLatest}
					scope={version.scope}
				/>
			)
		})
	}
	preprocessData = () => {
		const { summary } = this.state;
		this.props.summary.reports.map((report, repIndex) => {

			const exclusionsCountInSummaryWithinState = summary.reports[repIndex].versions.filter(version => version.exclusions && version.exclusions.length).length
			const exclusionsCountInNewSummary = report.versions.filter(version => version.exclusions && version.exclusions.length).length
			const hasExclusionsCountChanged = exclusionsCountInSummaryWithinState > exclusionsCountInNewSummary


			if (hasExclusionsCountChanged) {
				summary.reports[repIndex].versions.map((stateVersion, index) => {
					if (stateVersion.exclusions && stateVersion.exclusions.length && (!report.versions[index].exclusions || !report.versions[index].exclusions.length)) {
						stateVersion.exclusions = [];
						stateVersion.expanded = undefined;
					}
					return null
				})
			}

			report.versions.map((version, verIndex) => {
				const previousVersion = summary.reports[repIndex].versions[verIndex];
				if (!version.exclusions) version.exclusions = [];
				version.expanded = previousVersion.expanded === undefined ? true : previousVersion.expanded;
				return null
			})
			return null
		})
	}

	listByLanguage = () => {
		const { privateMode } = this.props;

		const Header = ({ language, hasVersions }) => {
			if (!hasVersions) return ""
			return (
				<div className="version-wrapper version-title">
					<div className="version-library"><b>Library ({language})</b></div>
					<div className="version-scope">&nbsp;</div>
					<div className="version-new-release"><b>New patch release</b></div>
					<div className="version-new-release"><b>New minor release</b></div>
					<div className="version-new-release"><b>New major release</b></div>
					{privateMode && !this.props.readonly && this.props.isLatest ? <div className="version-new-release"><b>Action</b></div> : null}
				</div>
			)
		}
		const Versions = ({ language, versions, repIndex }) => {
			return this.Versions(versions, language, repIndex)
		}

		const versionsList = []

		for (let repIndex = 0; repIndex < this.summary.reports.length; repIndex++) {
			const report = this.summary.reports[repIndex]
			if (!report.versions.length) continue

			// if (this.props.toggledLanguages.includes(report.language)) continue
			versionsList.push(
				<div data-language={report.language} id={`versions-div-${report.language}`} key={report.language} className="mb-5">
					<Header language={report.language} hasVersions={report.versions.length} />
					<Versions language={report.language}
						versions={report.versions}
						repIndex={repIndex}
					/>
					<div className="version-wrapper"></div>
				</div>
			)
		}

		return this.summary.reports.map((report, repIndex) => {
			if (!report.versions.length) return ""

			// if (this.props.toggledLanguages.includes(report.language)) return ""
			return (
				<div data-language={report.language}  id={`versions-div-${report.language}`} key={report.language} className="mb-5">
					<Header language={report.language} hasVersions={report.versions.length} />
					<Versions language={report.language}
						versions={report.versions}
						repIndex={repIndex}
					/>
					<div className="version-wrapper"></div>
				</div>
			)
		})

	}




	listComponents() {


		const LanguageEntries = ({ entry }) => {

			const clickThrough = () => {
				this.props.collapse(true)
			}

			const sortedComponents = entry.slice();

			sortedComponents.sort((a, b) => {
				if (a.newPatchVersionAvailable) return -1
				if (b.newPatchVersionAvailable) return 1
				return 0
			})

			sortedComponents.sort((a, b) => {
				if (a.newPatchVersionAvailable && (a.newMinorVersionAvailable || a.newMajorVersionAvailable)) return -1
				if (b.newPatchVersionAvailable && (b.newMinorVersionAvailable || b.newMajorVersionAvailable)) return 1
				return 0
			})

			return sortedComponents.map(component => {

				return (
					<tr key={component.name + component.version + "stability-summary"}>
						<td><a href={"#stability-" + component.name + component.version} onClick={clickThrough}>{component.name}</a></td>
						<td>{component.version}</td>
						<td className="text-center">{component.newPatchVersionAvailable ? <i className="fas fa-check" style={{ color: "red" }}></i> : ""}</td>
						<td className="text-center">{component.newMinorVersionAvailable || component.newMajorVersionAvailable ? <i className="fas fa-check" style={{ color: "orange" }}></i> : ""}</td>
					</tr>
				)
			})

		}

		const SummaryTable = () => {
			const hiddenLanguages = useSelector((state) => state.languagesFilter.toggledLanguages)
			this.summary.reports.map((current) => {
				current.empty = !current.versions.length
				return true
			})

			this.summary.reports.sort((a, b) => {
				if (!a.versions.length) return -1
				if (!b.versions.length) return -1
				return 0
			})

			return this.summary.reports.map(({ language, versions, empty }) => {
				if(hiddenLanguages.includes(language)) return
				return (
					<div id="version-summary" key={language + "-stability-summary"} className="col-lg-12 mb-3">

						<React.Fragment>
							<p className="mt-2 mb-1"><b>{language}</b></p>
							{
								empty ?
									<p className="w-100 text-center">No issues detected</p> :
									<table className="summary-table table table-condensed ">
										<thead>
											<tr>
												<th width="55%">Name</th>
												<th width="15%">Version</th>
												<th width="15%" className="text-center">Patch available</th>
												<th width="15%" className="text-center">Outdated</th>
											</tr>
										</thead>
										<tbody>
											<LanguageEntries entry={versions} />
										</tbody>
									</table>
							}
						</React.Fragment>
					</div>
				)
			})
		}

		return SummaryTable()
	}

	render() {

		const { display, summary } = this.props;
		this.summary = summary;
		this.preprocessData();
		const VersionsTable = () => {
			return this.listByLanguage();
		}
		const VersionsSummary = () => {
			return this.listComponents();
		}
		return (
			display ?
				<div className="row" id="versions-row">
					<div className="pb-3 col-lg-12">&nbsp;</div>
					<div className="col-md-12">
						<h3 className="report-header hide_if_not_ready d-inline" >
							<i className="fa fa-newspaper-o" style={{ color: "gray" }}></i> 
							<span name="dependencies-updates"> STABILITY ASSESSMENT</span>
						</h3>
						<i tabIndex={0} id="stability-minimizer" className={(this.props.collapsed ? "fa-plus-square" : "fa-minus-square") + " far fa-lg section-minimizer ml-2"} onClick={() => this.props.collapse(this.props.collapsed)} onKeyUp={(e)=>{if(e.key.toLocaleLowerCase()==="enter") this.props.collapse(this.props.collapsed)}}></i>
						<DownloadStabilityCSV summary={this.summary}/>
						{this.state.error ? <div className="report-box" id="error-versions">
							<div className="report-box-header red">
								<span className="glyphicon glyphicon-alert fa-fw"> </span>
								SOMETHING WENT WRONG HERE
							</div>
							<div className="report-box-text">
								We couldn't determine if there are updates for the dependencies you are currently using. It
								might be a temporary issue with our servers or
								the external service we are using. Please trying again in a few minutes, and if the problem
								persists please contact <a href="mailto:support@meterian.com">Meterian support</a>
								and we'll have a look for you.
							</div>
						</div> : null}
						<div className={this.props.collapsed ? "report-box-body" : ""} >
							{
								this.props.collapsed ?
									<VersionsSummary /> :
									<VersionsTable />
							}
						</div>
					</div>
				</div>
				: null
		)
	}
}

export default connect(mapStateAsProps, mapDispatchAsProps)(Stability);



